import {ACTION_CATEGORY, ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';

// Keep in sync with benchling/analytics/lib/reaction_analytics.py
export const REACTION_ANALYTICS_ACTIONS = {
  CREATED_REACTION: {
    module: ANALYTICS_MODULE.CHEMISTRY,
    action: 'created_reaction',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_REACTION: {
    module: ANALYTICS_MODULE.CHEMISTRY,
    action: 'updated_reaction',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
};
